import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// Components
import { Box, Button } from '@zolteam/zol-admin-ui';
import { useGetConfirmEmailAddressQuery } from '../../../services/parazol/parazolQueries';

/**
 * EmailConfirmed component.
 * @returns {JSX.Element}
 */
function EmailConfirmed() {
  // Hooks
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  // Params
  const token = searchParams.get('token');

  // Service
  const getConfirmEmailAddressQuery = useGetConfirmEmailAddressQuery(
    'redirect-url',
    token,
  );

  return (
    <Box direction="column" gap="m" fullWidth>
      <>
        <Box direction="column" gap="xs" align="center" fullWidth>
          <h1 className="h3-default font-weight-bold">
            {t('cortizol.emailConfirmed.title')}
          </h1>
          <span className="p1-default">
            {t('cortizol.emailConfirmed.description')}
          </span>
        </Box>

        <Box direction="column" gap="xs" align="normal" fullWidth>
          <Button color="noBackground" isLoading={getConfirmEmailAddressQuery.isLoading}>
            <Link to="/login">
              {t('cortizol.emailConfirmed.login')}
            </Link>
          </Button>
        </Box>
      </>
    </Box>
  );
}

export default EmailConfirmed;
